import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize, map, Observable } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { helper } from 'src/environments/helper';
import { DirectieSerii } from '../directie-serii.interface';
import { DirectieSeriiService } from '../directie-serii.service';
import { notDefaultValidator } from 'src/app/validators/not-default';
import { Generic } from 'src/app/interfaces/generic.interface';
import { CommonService } from 'src/app/services/common.service';

@Component({
    selector: 'app-add-serie',
    templateUrl: './add-serie.component.html',
    styleUrls: ['./add-serie.component.scss']
})
export class AddSerieComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    serie$!: Observable<Generic[]>;

    defaultParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    form: FormGroup = new FormGroup({
        id_sequence: new FormControl(-1, [Validators.required, notDefaultValidator('-1')]),
        prefix: new FormControl(null, []),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: DirectieSerii,
        private dialogRef: MatDialogRef<AddSerieComponent>,
        private requestService: DirectieSeriiService,
        private notificationService: NotificationService,
        private commonService: CommonService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    ngOnInit() {
        this.getActiveSerie();
        this.findEntryData();
    }

    getActiveSerie() {
        this.isLoading = true;
        this.serie$ = this.commonService
            .getSeriiActive()
            .pipe(
                finalize(() => (this.isLoading = false)),
                map((resp: Generic[]) => [this.defaultParameter, ...resp])
            );
    }

    findEntryData() {
        this.requestService.findEntry(this.data.directie_id, this.data.id_compartiment)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe((res: any) => {
                const entryData: { id_sequence: string | -1, prefix: string | null } = res.data;
                console.log(entryData);
                this.form.get('prefix')?.setValue(res.data.prefix);
            });
    }

    submitForm() {
        this.isLoading = true;

        const { id_sequence, prefix } = this.form.value;
        const payload = {
            id_sequence,
            prefix
        };

        this.requestService.addSerie(this.data.directie_id, this.data.id_compartiment, payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
